export default "__VITE_ASSET__W7Lv4uZr__"